import { gql, TypedDocumentNode } from "@apollo/client";

import {
  MutationBlueprintDeploymentCreateArgs,
  MutationBlueprintDeploymentUpdateArgs,
  BlueprintDeployment,
} from "types/generated";

type FetchBlueprintCreateStack = {
  blueprintDeploymentCreate: BlueprintDeployment;
};

export const BLUEPRINT_CREATE_STACK: TypedDocumentNode<
  FetchBlueprintCreateStack,
  MutationBlueprintDeploymentCreateArgs
> = gql`
  mutation BlueprintCreateDeployment($id: ID!, $input: BlueprintDeploymentCreateInput!) {
    blueprintDeploymentCreate(id: $id, input: $input) {
      id
      name
    }
  }
`;

type FetchBlueprintUpdateDeployment = {
  blueprintDeploymentUpdate: BlueprintDeployment;
};

export const BLUEPRINT_UPDATE_DEPLOYMENT: TypedDocumentNode<
  FetchBlueprintUpdateDeployment,
  MutationBlueprintDeploymentUpdateArgs
> = gql`
  mutation BlueprintUpdateDeployment(
    $blueprintID: ID!
    $id: ID!
    $input: BlueprintDeploymentUpdateInput!
  ) {
    blueprintDeploymentUpdate(blueprintID: $blueprintID, id: $id, input: $input) {
      id
      name
    }
  }
`;
